function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.8978675645342312s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(40 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.7856341189674523s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(80 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.6734006734006734s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.5611672278338945s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(160 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.4489337822671156s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(200 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.3367003367003367s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.2244668911335578s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(280 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "-0.1122334455667789s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(320 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#bbbbbb",
  height: 11,
  width: 6,
  ry: 2.64,
  rx: 2.64,
  y: 26.5,
  x: 47
}, /*#__PURE__*/React.createElement("animate", {
  repeatCount: "indefinite",
  begin: "0s",
  dur: "1.0101010101010102s",
  keyTimes: "0;1",
  values: "1;0",
  attributeName: "opacity"
}))), /*#__PURE__*/React.createElement("g", null));

var SvgSimpleSpinner = function SvgSimpleSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimpleSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simple_spinner.e8a7c02a.svg";
export { ForwardRef as ReactComponent };